import { Controller } from "@hotwired/stimulus";
import "./component.scss";

// Disclosure behind the "Erstellen" button: toggles on the trigger, closes on
// an item click, an outside click or Escape.
export default class extends Controller {
  static targets = ["trigger", "popover"];

  connect() {
    this.boundOutside = this.outside.bind(this);
  }

  disconnect() {
    this.close();
  }

  toggle(event) {
    this.isOpen ? this.close() : this.open(event);
  }

  open(event) {
    this.popoverTarget.hidden = false;
    this.triggerTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.boundOutside);
    // Keyboard users land on the first entry; a pointer click keeps its focus.
    if (event?.detail === 0) this.popoverTarget.querySelector("a")?.focus();
  }

  close() {
    if (!this.isOpen) return;

    this.popoverTarget.hidden = true;
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.boundOutside);
  }

  closeAndFocus() {
    if (!this.isOpen) return;

    this.close();
    this.triggerTarget.focus();
  }

  outside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  get isOpen() {
    return !this.popoverTarget.hidden;
  }
}
